const fetch = {}

const request = (options) => {
  let toUpper = function (str) {
    return str ? str.toUpperCase() : ''
  }

  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    let xhrHandler = () => {
      if (xhr.readyState !== 4) return
      if (xhr.status === 200 || xhr.status === 304) {
        resolve(xhr.response)
      } else {
        reject(xhr.response)
      }
    }
    xhr.addEventListener('readystatechange', xhrHandler)
    options.callback && xhr.upload.addEventListener('progress', options.callback);
    xhr.open(toUpper(options.method) || 'GET', options.url)

    xhr.responseType = options.resType || 'json'
    sessionStorage.token && xhr.setRequestHeader('AUTHORIZATION', sessionStorage.token);

    if (options.headers) {
      for (let i in options.headers) {
        xhr.setRequestHeader(i, options.headers[i])
      }
    }
    options.body ? xhr.send(Object.prototype.toString.call(options.body).includes('FormData') ? options.body : JSON.stringify(options.body)) : xhr.send()
  })
}

['get', 'delete'].map(method => {
  fetch[method] = (url, headers, resType) => {
    return request(Object.assign(headers || {}, {
      url,
      method,
      resType
    }))
  }
});

['post', 'put', 'patch'].map(method => {
  fetch[method] = (url, body, headers, callback) => {
    return request(Object.assign(Object.assign(headers || {}, Object.prototype.toString.call(body).includes('FormData') ? {} : {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }), {
      url: url,
      method: method,
      body: body,
      callback
    }))
  }
})

export default fetch
